// Bridges the PayU redirect gap for owed-lesson payments. PayU's continueUrl
// is a static page with no order context, so before redirecting we stash WHICH
// lessons the user is paying for; after they land back, DebtPaymentResultNotice
// reads the stash, re-fetches /user/me/owed and tells the user exactly what got
// settled ("Opłacono: Silne Ciało, 23.07"). Without this the user pays blind
// and assumes ALL debt is gone — which is how "zapłaciłam, a system pokazuje
// dług" complaints happen when a new lesson creates fresh debt the same day.

const STORAGE_KEY = "pendingDebtPayment";

// PayU notify lands within seconds; anything older than this is a stale stash
// (abandoned checkout, failed payment) and must not trigger a notice.
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

export const savePendingDebtPayment = (lessons) => {
  try {
    const record = {
      ts: Date.now(),
      lessons: lessons.map((l) => ({
        lesson_id: l.lesson_id,
        lesson_name: l.lesson_name,
        // signup-modal debt items carry `lesson_date`, /owed items `lesson_start`
        lesson_date: l.lesson_date || l.lesson_start,
        price: l.price,
      })),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // Storage unavailable (private mode etc.) — the payment still works,
    // we just lose the post-payment notice.
  }
};

export const readPendingDebtPayment = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const record = JSON.parse(raw);
    if (
      !record ||
      !Array.isArray(record.lessons) ||
      record.lessons.length === 0 ||
      !record.ts ||
      Date.now() - record.ts > MAX_AGE_MS
    ) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return record;
  } catch {
    return null;
  }
};

export const clearPendingDebtPayment = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
